import React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AppShell from "@/components/platform/AppShell";
import { PageTitle } from "@/components/platform/Badges";
import { OrgSettingsForm } from "@/components/platform/OrgSettingsForm";
import { UsersPanel } from "@/components/platform/UsersPanel";
import { PermissionMatrix } from "@/components/platform/PermissionMatrix";
import { OutboxPanel, TenantsPanel } from "@/components/platform/TenantsPanel";
import { SupportRequestsPanel } from "@/components/platform/SupportMode";
import { useAuth } from "@/context/AuthContext";

export default function Settings() {
  const auth = useAuth();
  const [params, setParams] = useSearchParams();
  const isPA = auth.user?.grc_role === "platform_admin";
  const tabs = [
    ["organization", "Organization", auth.can("tenant_settings", "view"), <OrgSettingsForm key="o" />],
    ["users", "Users & Roles", auth.can("users", "view"), <UsersPanel key="u" />],
    ["permissions", "Permission Matrix", auth.can("users", "view"), <PermissionMatrix key="p" />],
    ["support", "Support Access", auth.can("users", "view"), <SupportRequestsPanel key="sp" />],
    ["email", "Email Outbox", auth.can("tenant_settings", "edit"), <OutboxPanel key="e" />],
    ["tenants", "Organizations", isPA, <TenantsPanel key="t" />],
  ].filter((t) => t[2]);
  const active = params.get("tab") && tabs.some((t) => t[0] === params.get("tab")) ? params.get("tab") : tabs[0]?.[0];

  return (
    <AppShell testId="settings-page">
      <PageTitle eyebrow={auth.user?.tenant_name} title="Settings"
                 subtitle="Organization profile, users, roles and the module-level permission matrix for this tenant." />
      <Tabs value={active} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="bg-white border border-slate-200">
          {tabs.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`settings-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        {tabs.map(([k, , , el]) => <TabsContent key={k} value={k} className="mt-5">{el}</TabsContent>)}
      </Tabs>
    </AppShell>
  );
}
